module.exports = __webpack_public_path__ + "static/media/1_MIAB9914-180731-127_Small.270b1dd2.jpg";